function fn_part_slider_brands() {
    var slider = $(".part-slider-brands");
    var slider_inner = $(".part-slider-brands").find(".inner");
    if (slider_inner.length) {
        slider_inner.slick({
            lazyLoad: 'progressive',
            infinite: true,
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 6000,
            fade: false,
            cssEase: 'linear',
            arrows: true,
            dots: false,
            adaptiveHeight: false,
            pauseOnHover: true,
            responsive: [
                {
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 4,
                        autoplay: false
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        autoplay: false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        autoplay: false
                    }
                }
            ]
        });
        //slider_inner.find(".slick-active").next().find("img").addClass("lazyload");
        // slider_inner.on('afterChange', function () {
        //     $(this).find(".slick-active").find("img").addClass("lazyload");
        //     if ($(this).find(".slick-active").data('ga-promo')) {
        //         GAsendPromo($(this).find(".slick-active"));
        //     }
        // });
    }
}